import {
  char,
  integer,
  pgTable,
  primaryKey,
  timestamp,
} from 'drizzle-orm/pg-core';

/** US = national aggregate row (import/export label: NATIONAL). */
export const NATIONAL_STATE_CODE = 'US';

export const stateProductCountsTable = pgTable(
  'state_product_counts',
  {
    state: char({ length: 2 }).notNull(),
    plan_year: integer().notNull(),
    ma_only: integer().notNull().default(0),
    ma_pd: integer().notNull().default(0),
    ma_sub: integer().notNull().default(0),
    pdp: integer().notNull().default(0),
    med_sup: integer().notNull().default(0),
    total: integer().notNull().default(0),
    updated_at: timestamp({ withTimezone: true }).defaultNow(),
  },
  (table) => [primaryKey({ columns: [table.state, table.plan_year] })]
);

export type DBStateProductCount = typeof stateProductCountsTable.$inferSelect;
